import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit8-conclusion',
  templateUrl: './unit8-conclusion.component.html',
  styleUrls: ['./unit8-conclusion.component.css']
})
export class Unit8ConclusionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
